<template>
  <div class="animated fadeIn list-of-coa">
    <b-card>
      <div slot="header">Serah Terima Dokumen
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <b-button variant="primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="primary mr-1" @click="deleteConfirm">Delete</b-button>
          <b-button variant="btn btn-primary mr-1" @click="print">Print</b-button>
          <b-button variant="btn btn-primary mr-1" @click="exportXls">Export</b-button>
          <b-button variant="btn btn-primary" @click="close">Close</b-button>
        </div>
      </div>
      <b-row>
        <b-col lg="3">
            <b-input-group>
                <b-input-group-prepend><label>Nomor Dokumen</label></b-input-group-prepend>
                <b-form-input v-model="tblData.doc_nomor"></b-form-input>
            </b-input-group>
              <b-input-group>
                  <b-input-group-prepend><label>Kelompok Dokumen</label></b-input-group-prepend>
                  <b-form-select v-model="tblData.doc_kelompok" :plain="true" :options="doctypesAll"></b-form-select>
              </b-input-group>
        </b-col>
        <b-col lg="5">
            <b-input-group>
                <b-input-group-prepend><label>Atas nama Dok.</label></b-input-group-prepend>
                <b-form-input v-model="tblData.doc_atasnama"></b-form-input>
            </b-input-group>
            <b-input-group>
                <b-input-group-prepend><label>Isi Dokumen</label></b-input-group-prepend>
                <b-form-input v-model="tblData.doc_isinya"></b-form-input>
            </b-input-group>
        </b-col>
        <b-col lg="4">
              <b-input-group>
                <b-input-group-prepend><label>Yang Menerima</label></b-input-group-prepend>
                <b-form-input v-model="tblData.penerima"></b-form-input>
              </b-input-group>
            <b-input-group>
                  <b-input-group-prepend><label>Yang menyerahkan</label></b-input-group-prepend>
                  <b-form-input v-model="tblData.penyerah"></b-form-input>
                <b-input-group-append>
                    <b-button class="btn btn-success ml-3" @click="refresh()" > <i class="fa fa-refresh"></i> Apply</b-button>
                </b-input-group-append>
                <b-input-group-append>
                  <b-button class="btn btn-secondary ml-1" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear</b-button>
                </b-input-group-append>
            </b-input-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="4">
        </b-col>
        <b-col lg="6">
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="4">
        </b-col>
        <b-col lg="6">
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive striped hover
        style="font-size:smaller;" 
        :items="data"
        :fields="fields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        @filtered="onFiltered"  @row-clicked="rowClicked" 
      >
        <template v-slot:cell(trxdate)="data">
          {{data.item.trxdate | moment('DD-MMM-YYYY HH:mm:ss')}}
        </template>

        <template v-slot:cell(action)="data">
          <div class="text-center">
          <a href="javascript:void(0)" @click="edit(data.item)">
            <i class="fa fa-pencil"></i>
          </a>
          |
          <a href="javascript:void(0)" class="text-danger" @click="deleteConfirm(data.item)">
            <i class="fa fa-trash"></i>
          </a>
          </div>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4" >
            <b-form-group label-cols=3 label="Limit per page" class="mb-0">
            <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  style="width:80px;"/>
            </b-form-group>
        </b-col>        
        <b-col cols="4">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    <b-modal v-model="showForm" header-bg-variant="primary"  :title="formTitle" size="lg" :centered="true" @ok="saveForm">
          <b-row>
              <b-col lg="6">
                  <b-input-group >
                      <b-input-group-prepend><label>Tanggal&Jam</label></b-input-group-prepend>
                      <b-input-group-append><VueCtkDateTimePicker v-model="frmdata.trxdate" :state="!$v.frmdata.trxdate.$error" style="width: 230px !important;"></VueCtkDateTimePicker> </b-input-group-append>                                                
                  </b-input-group>
              </b-col>
              <b-col lg="6">
                  <b-input-group >
                      <b-input-group-prepend><label>Yang Menyerahkan</label></b-input-group-prepend>
                      <b-form-input v-model="frmdata.penyerah" ></b-form-input>
                  </b-input-group>

              </b-col>
          </b-row>
          <b-row>
              <b-col lg="6">
                <b-input-group>
                    <b-input-group-prepend><label>Nomor Dokumen</label></b-input-group-prepend>
                    <b-form-input v-model="frmdata.doc_nomor" :state="!$v.frmdata.doc_nomor.$error"></b-form-input>
                </b-input-group>
              </b-col>
              <b-col lg="6">
                <b-input-group>
                    <b-input-group-prepend><label>Kelompok Dokumen</label></b-input-group-prepend>
                    <b-form-select v-model="frmdata.doc_kelompok" :state="!$v.frmdata.doc_kelompok.$error" :plain="true" :options="doctypes"></b-form-select>
                </b-input-group>
              </b-col>
          </b-row>

          <b-input-group>
              <b-input-group-prepend><label>Atasnama Dokumen</label></b-input-group-prepend>
              <b-form-input v-model="frmdata.doc_atasnama" :state="!$v.frmdata.doc_atasnama.$error"></b-form-input>
          </b-input-group>
          <b-input-group>
              <b-input-group-prepend><label>Isi Dokumen</label></b-input-group-prepend>
              <b-form-textarea :rows="3" :max-rows="6" v-model="frmdata.doc_isinya" :state="!$v.frmdata.doc_isinya.$error"></b-form-textarea>
          </b-input-group>
          <b-input-group >
              <b-input-group-prepend><label>Penerima</label></b-input-group-prepend>
              <b-form-input v-model="frmdata.penerima" :state="!$v.frmdata.penerima.$error"></b-form-input>
          </b-input-group>
          <b-input-group >
              <b-input-group-prepend><label>Keperluan</label></b-input-group-prepend>
              <b-form-input v-model="frmdata.keperluan" :state="!$v.frmdata.keperluan.$error" ></b-form-input>
          </b-input-group>

    </b-modal>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Print - Tanda Terima Dokumen">
        <iframe v-if="reportUrl" :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
  </div>
</template>

<style lang="scss">
  .list-of-coa {
    iframe {
      border: 1px solid #ccc;
      width: 100%;
      height: 11in;
    }
  }
</style>


<script>
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import moment from "moment";
import cirdoc from "../apis/circulationdoc";
import { validationMixin } from "vuelidate";
import { required, maxLength,numeric } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    frmdata: {
      doc_nomor: { required },
      doc_atasnama: { required },
      doc_kelompok: { required },
      doc_isinya: { required },
      trxdate: { required },
      keperluan: { required },
      penerima: { required },
    }
  },  
  components: { VueCtkDateTimePicker, Loading },
  data() {
    return {
      doctypes:[],
      doctypesAll:[{value:'', text:'--ALL--'}],
      formTitle: 'Add Record - Serah Terima Dokumen',
      saveEnabled:true,
      showForm:false,
      showReport:false,
      showDelConfirm: false,
      isLoading : false,
      model:{},
    frmdata: {
      doc_nomor: '',
      doc_atasnama: '',
      doc_kelompok: '',
      doc_isinya: '',
      trxdate: null,
      penerima: '', keperluan:'', penyerah: this.$store.state.user.username
    },
    items:[],
        fields: [
          {
            key: "trxdate",
            thStyle: "width:120px",
            label: "Tanggal",
            sortable: true,
            thClass: "text-center",
            tdClass: "text-center"
          },
          {
            key: "doc_nomor",
            label: "Nomor Dokumen",
            sortable: true,
            thClass: "text-center",
            tdClass: "text-center"
          },
          {
            key: "doc_atasnama",
            label: "Dokumen Atasnama",
            sortable: true
          },
          {
            key: "doc_isinya",
            label: "Isi Dokumen"
          },
          {
            key: "penyerah",
            label: "Yang Menyerahkan",
            sortable: true,
            thClass: "text-center",
            tdClass: "text-center"
          },
          {
            key: "penerima",
            label: "Yang Menerima",
            sortable: true,
            thClass: "text-center",
            tdClass: "text-center"
          },
          {
            key: "keperluan",
            label: "Keperluan",
            sortable: true,
            thClass: "text-center",
            tdClass: "text-center"
          },
          {
            key: "kelompok",
            label: "Kelompok Dokumen",
            sortable: true,
            thClass: "text-center",
            tdClass: "text-center"
          },
          {
            key: "action",
            label: "Action",
            thClass: "text-center",
          },

        ],
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        penyerah: this.$store.state.user.username,
        sortBy: null,
        sortDesc: false,
      },
      reportUrl: null,
    };
  },
  created: async function() {
      this.doctypes = await cirdoc.group();
      this.doctypesAll = this.doctypesAll.concat(this.doctypes);
  },
  computed: {
    isValid() {
      this.$v.frmdata.$touch();
      return !this.$v.frmdata.$invalid;
    }
  },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
    //   this.tblData.namaacc = this.tblData.filter;

      const list = await cirdoc.list(this.tblData);   
      this.items = list;   
      return list;
    },
    add: function() {
      this.model = { kodeacc: '', namaacc:'' };
      this.formTitle='Add Record - Serah Terima Dokumen';
      for (var key in this.frmdata) {
            this.frmdata[key] = '';
      }      
      this.frmdata.penyerah= this.$store.state.user.username;    
      this.frmdata.trxdate=moment();
      this.frmdata.trxkey = '';
      this.showForm = true;
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    edit: function() {
        if (this.model.trxkey) {
          this.editData(this.model);
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },
    editData: function(data) {
      for (var key in this.frmdata) {
            this.frmdata[key] = '';
      }      
      for (var key in data) {
          if (data[key]){
            this.frmdata[key] = data[key];
          }
      }      
      // this.frmdata = item;
      this.formTitle='Edit - Serah Terima Dokumen';
      this.showForm = true;
    },
    delete() {
        if (this.model.trxkey) {
          this.deleteConfirm(this.model);
          this.showDelConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be Delete!');
        }
    },
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      try {
        this.isLoading=true;
        await cirdoc.remove(this.model);
        // this.refresh();
        const index= this.items.findIndex(r => (r.trxkey==this.model.trxkey));
        this.items.splice(index, 1);
        this.isLoading=false;
      } catch (error) {
          console.log('save : ', error)
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
          } else {
              toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
          }        
        this.saveEnabled=true;            
      }
    },

    saveForm: function(evt) {
      const { model, isValid } = this;
        // console.log('isValid : ', isValid)
      evt.preventDefault()
      if (!isValid) {
        alert('FORM belum diisi dengan Lengkap !')
      } else {
        this.save()
      }
    },
    save: async function() {
        if (!this.saveEnabled) {
            return;
        }
        this.saveEnabled=false;            
      const { frmdata, isValid } = this;
      if (isValid==true) {
        try {
          const model= {
            doc_nomor: frmdata.doc_nomor,
            doc_atasnama: frmdata.doc_atasnama,
            doc_kelompok: frmdata.doc_kelompok,
            doc_isinya: frmdata.doc_isinya,
            trxdate: moment(frmdata.trxdate).format('YYYY-MM-DD HH:mm:ss'),
            penerima: frmdata.penerima, 
            keperluan: frmdata.keperluan, 
            penyerah: frmdata.penyerah
          }
          model.trxkey = frmdata.trxkey || '';
          if (this.formTitle == "Add - Serah Terima Dokumen") {
            await cirdoc.save(model);
          } else {
            await cirdoc.save(model);
          }
          this.saveEnabled= true;
          this.showForm = false;
          this.refresh();
        } catch (error) {
            console.log('save : ', error)
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
          this.saveEnabled=true;            
        }
      }
    },
    print: async function() {
          try {
                this.showReport=true;
              this.reportUrl= await cirdoc.print(this.model);
          } catch (error) {
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
    },
    exportXls:async  function() {
          try {
              this.Loading=true;
              await cirdoc.exportXls(this.tblData);
              this.Loading=false;
          } catch (error) {
              this.Loading=false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
    },
    refresh() {
      this.$refs.table.refresh();
    },
    clearFilter(ctx) {
        this.tblData.doc_nomor =  '';
        this.tblData.doc_atasnama =  '';
        this.tblData.doc_kelompok =  '';
        this.tblData.doc_isinya =  '';
        this.tblData.penyerah = '';
        this.tblData.penerima = '';
        // this.refresh();
    },    

    close(){
      // router.push("home");
      router.push({name:"app.modules"});
    }    
  }
};
</script>
